// extracted by mini-css-extract-plugin
export default {"btnWrapper":"LikeDislikeChart_btnWrapper__KctJU","likeBtn":"LikeDislikeChart_likeBtn__uWSlK","dislikeBtn":"LikeDislikeChart_dislikeBtn__D3r-n","img":"LikeDislikeChart_img__hLNzw"};